import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Paper} from '@material-ui/core';

import SqlRequest from '../../../../api/sql/SqlRequest';
import { base64toGuid, getObjectByID } from '../../../../api/helpers';
import NativeTable from '../../../../api/sql/NativeTable';

import { ReportCallRecordingFilter } from './ReportCallRecordingFilter';
import { ReportCallRecordingList } from './ReportCallRecordingList';
import { formatDateToFileName } from '../../../../api/date';
import { RecordPlayer } from '../RecordPlayer/RecordPlayer';


class ReportCallRecordingPanel_ extends React.Component {

    constructor(props) {
        super(props)

        const time = new Date()
        const dateFrom = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0 )
        const dateTo = new Date(time.getFullYear(), time.getMonth(), time.getDate()+1, 0, 0 )
        

        this.state = {
            filter: {
                dateFrom: dateFrom,
                dateTo: dateTo,
                networkID: props.networkID,
                search: '',
                eventFilter: 0,
                //userID: null,
                user: ''
            },
            reportData: {columns:[], rows:[], version:null},
            player: {
                open: false,
                records: null
            }
        }

        this.handleFilterChange = this.handleFilterChange.bind(this)

        this.handleQueryComplete = this.handleQueryComplete.bind(this)

        this.handleAction = this.handleAction.bind(this)

        this.handleReportRequestComplete = this.handleReportRequestComplete.bind(this)
    }
    
    componentDidMount(){
        this.handleFilterChange(this.state.filter)
    }

    handleFilterChange(filter){
        this.setState({filter: filter})
        console.log('filter:')
        console.log(filter)
    }


    handleQueryComplete(events){
        //alert('query complete')
        console.log('handleQueryComplete')
        console.log(events)
        this.setState({events: events})
    }

    handleAction(action){
        switch(action.type){

            case 'FILTER_CHANGE':{
                this.setState({filter: action.filter})
                break
            }
            case 'FILTER_APPLY':{
                this.applyFilter(action.filter)
                break
            }

            case 'RESOURCE_DOWNLOAD':{
                console.log('RESOURCE_DOWNLOAD')
                console.log(action)
                let rows = action.rows

                rows.map((row)=>{
            
                    let resourceType = row.calltype===1 || row.calltype===3 ? 1 : 2 

                    let filename = formatDateToFileName(row.edt) + ' (' + row.fromname + '-' + row.toname + ').mp3'

                    this.props.onAction({
                        type: 'RESOURCE_DOWNLOAD', 
                        resourceType: resourceType, 
                        resourceID: row.euuid,
                        networkID: row.networkid,
                        filename: filename
                    })

                })

                break
            }

            case 'RESOURCE_GET':{
                console.log('RESOURCE_GET')
                console.log(action)
                let row = action.row

                //rows.map((row)=>{

                    let resourceType = row.calltype==1 || row.calltype==3 ? 1 : 2 

                    let filename = formatDateToFileName(row.edt) + ' (' + row.fromname + '-' + row.toname + ').mp3'
    
                    this.props.onAction({
                        type: 'RESOURCE_GET', 
                        resourceType: resourceType, 
                        resourceID: row.euuid,
                        networkID: row.networkid,
                        filename: filename,
                        onComplete: action.onComplete
                    })

                //})

                break
            }

            case 'RESOURCE_PLAY':{
                console.log('RESOURCE_PLAY')
                console.log(action)

                let rows = action.rows

                this.setState(  {player: {
                    open: true,
                    records: rows,
                    version: action.version
                }})

                break
            }

            case 'RESOURCE_PLAY_CLOSE':{

                this.setState(  {player: {
                    open: false,
                    records: null
                }})

                break
            }

            default: {
                console.error('Unknown action')
                console.error(action)
            }

        }
    }

    applyFilter(f){

        let networkID = f.networkID ? f.networkID : this.props.networkID 

        let networkGUID = base64toGuid(networkID)

        const sqlRequest = new SqlRequest(networkID, this.handleReportRequestComplete)

        let where = ' state=3 '

        /*
        if(f.userID){
            where += " and userid ='" + base64toGuid(f.userID) + "'";
        }
        */

        if (f.eventFilter!==0){
            where += " and callType = "+f.eventFilter;
        }else{
            where += " and (callType = 1 or callType = 3 or callType = 11 or callType = 12)"
        }

        let searchString = f.search.replace("'", "''")
        if (searchString.length > 0){
            where += " and (fromname like '%"+searchString+"%' or toname like '%"+searchString+"%')"
        }
            

        if(f.dateFrom){
            const dateFrom = f.dateFrom.getTime()
            console.log('dateFrom')
            console.log(dateFrom)
            where +=  " and edt >= @p1 "
            const ext1 = sqlRequest.parameterExtension('System.DateTime', "p1", dateFrom)
            sqlRequest.addExtension("selectConnectDisconnect", ext1)
        }
        if(f.dateTo){
            const dateTo = f.dateTo.getTime()
            console.log('dateTo')
            console.log(dateTo)
            where +=  " and edt <= @p2 "
            const ext2 = sqlRequest.parameterExtension('System.DateTime', "p2", dateTo)
            sqlRequest.addExtension("selectConnectDisconnect", ext2)
        }
        
/*
        let sql = "SELECT TOP 10000 dt, userName, CASE isDispatcher WHEN 1 THEN 'x' WHEN 0 THEN ' ' END as dispatcher, event, manufacturer, model "+
                    "from events inner join devices on events.deviceid=devices.id "+
                    "WHERE " + where;
                    */

        let sql = "select * " +
                    "from (" +
                    "SELECT cast('"+networkGUID+"' as uniqueidentifier) as networkid, calls.id as euuid, calls.dt as edt, "+
                    "  (calls.time / 1000) as duration, calls.callType as calltype, calls.state, calls.fromname, calls.toname "+
                    "FROM calls) as tbl " + 
                    "WHERE " + where + " " +
                    "ORDER by edt DESC"
        

        console.log(sql)

        sqlRequest.addQuery("selectConnectDisconnect", sql)

        
        //this.api.querySql(sqlRequest)

        this.props.onAction({type: 'SQL_REQUEST', request: sqlRequest })
    }

    handleReportRequestComplete(results){

        console.log('handleReportRequestComplete')

        console.log(results)

        const data = getObjectByID('selectConnectDisconnect', results, 'Key')

        console.log('data')
        console.log(data)

        const table = new NativeTable(data.Result)

        const dataTable = table.toDataTable()

        console.log('dataTable')
        console.log(dataTable)

        this.setState({reportData: dataTable})

    }



    render(){

        let player = this.state.player.open ? (
            <RecordPlayer open={true} {...this.state.player} onAction={this.handleAction}></RecordPlayer>
        ) : ''

        return(
            <>
            {player}
            <Paper style={{marginBottom:16}}>
                <ReportCallRecordingFilter 
                    networks={this.props.networks} 
                    onAction={this.handleAction} 
                    onChange={this.handleFilterChange} 
                    filter={this.state.filter}/>
                <ReportCallRecordingList 
                    onAction={this.handleAction} 
                    reportData={this.state.reportData} />
            </Paper>
            </>
        );
            //eventLogger={this.props.eventLogger} filter={this.state.filter}
    }

}

export const ReportCallRecordingPanel = withTranslation()(ReportCallRecordingPanel_);